module.exports = __webpack_public_path__ + "static/img/idea.8d7cf13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/idea.png
// module id = mfFw
// module chunks = 0